import { GroupedOption } from './models/option.model';
import { Project } from './models/project.model';

export function groupProjects(projects: Project[]): GroupedOption[] {
  const groupedProjects = projects.reduce((acc, proj) => {
    const group = proj.group || 'Ungrouped';
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push({
      value: proj._id,
      label: proj.label || proj._id,
    });
    return acc;
  }, {});

  const keys = Object.keys(groupedProjects);
  return keys.map(group =>
    ({ title: group, options: groupedProjects[group] })
  );
}

export function isExternalStorage(storage: string): boolean {
  return storage.split('').some(char => char !== '0');
}
